'use client';

import { ResetPasswordOutput, resetPassword as amplifyResetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { useCallback } from 'react';
import { MetaObject } from '@/types';

export interface AuthActions {
  forgotPassword: (email: string, clientMetadata?: MetaObject) => Promise<ResetPasswordOutput>;
  resetPassword: (username: string, code: string, password: string, clientMetadata?: MetaObject) => Promise<void>;
}

export const useAuthActions = () => {
  const forgotPassword = useCallback(async (email: string, clientMetadata?: MetaObject) => {
    return amplifyResetPassword({
      username: email,
      options: {
        clientMetadata,
      },
    });
  }, []);

  const resetPassword = useCallback(
    async (username: string, confirmationCode: string, password: string, clientMetadata?: MetaObject) => {
      return confirmResetPassword({
        username,
        confirmationCode,
        newPassword: password,
        options: {
          clientMetadata,
        },
      });
    },
    []
  );

  return {
    resetPassword,
    forgotPassword,
  };
};
